import {Vue, Component, Prop, Emit} from 'vue-property-decorator'


@Component
class CrudMenu extends Vue {

  @Prop({ default: () =>  ({ edit: false, delete: false}), type: [Object] })
  auths: { edit: boolean, delete: boolean }
  @Prop({ default: () => ({}) , type: [Object] })
  texts: { edit: string, delete: string }

  dtActionOpen: boolean

  constructor(){
    super()

    this.dtActionOpen= false
  }


  @Emit("edit")
  handleEdit(){
    this.dtActionOpen= false
  }

  @Emit("delete")
  handleDelete(){
    this.dtActionOpen= false
  }

  @Emit("scheduleMaintenance")
  handleScheduleMaintenance()
  {
    this.dtActionOpen= false
  }

  @Emit("addDocToEquipment")
  handleAddDocToEquipment()
  {
    this.dtActionOpen= false
  }

}

export default CrudMenu



// WEBPACK FOOTER //
// ./src/components/crud-menu/index.ts